"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var close_icon_1 = require("../../../svg/close.icon");
var slaGraph_icon_1 = require("../../../svg/slaGraph.icon");
var core_components_1 = require("@securityproducts/core-components");
var slaConfigure_i18n_1 = require("./slaConfigure.i18n");
var slaConfigure_styles_1 = require("./slaConfigure.styles");
function SlaConfigure(props) {
    var _a = React.useState(props.sla || "0"), sla = _a[0], setSla = _a[1];
    var _b = React.useState(undefined), slaValidation = _b[0], setSlaValidation = _b[1];
    var strings = core_components_1.useLocalisation(slaConfigure_i18n_1.slaConfigureTranslations, props.language);
    var infoText = React.createElement("div", { className: slaConfigure_styles_1.tooltip }, strings.infoText);
    function validateSla() {
        if (sla < 5) {
            setSlaValidation(strings.minSlaValue);
        }
        else if (sla > 1200) {
            setSlaValidation(strings.maxSlaValue);
        }
        else {
            setSlaValidation(null);
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: slaConfigure_styles_1.blockedView }),
        React.createElement("div", { id: "sla-modal", className: slaConfigure_styles_1.modal },
            React.createElement("div", { className: slaConfigure_styles_1.linkArea },
                React.createElement("div", { className: slaConfigure_styles_1.title },
                    strings.configureSla,
                    React.createElement(core_components_1.SectionTitlesTooltip, { id: "sla-configure-tooltip", html: infoText })),
                React.createElement("div", { className: slaConfigure_styles_1.close, onClick: function () {
                        props.setModalClose();
                    } },
                    React.createElement(close_icon_1.CloseIcon, null))),
            React.createElement("div", { className: slaConfigure_styles_1.content },
                React.createElement(slaGraph_icon_1.SlaGraphIcon, null),
                React.createElement("div", null,
                    React.createElement("div", { className: slaConfigure_styles_1.inputRow },
                        React.createElement("label", { className: slaConfigure_styles_1.slaLabel },
                            " ",
                            strings.slaLabel2,
                            " "),
                        React.createElement("input", { type: "text", id: "slaValue2", disabled: true, value: Number(sla) * 2 }),
                        React.createElement("label", { className: slaConfigure_styles_1.reEnable }, strings.seconds)),
                    React.createElement("div", { className: slaConfigure_styles_1.inputRow },
                        React.createElement("label", { className: slaConfigure_styles_1.slaLabel }, strings.slaLabel1),
                        React.createElement("input", { type: "number", id: "slaValue1", "data-testid": "slaValue1", value: sla, onChange: function (e) {
                                setSla(e.target.value);
                            }, onBlur: validateSla, className: slaValidation && "error" }),
                        slaValidation && (React.createElement("p", { id: "sla-validation", "data-testid": "sla-validation", className: "" + slaConfigure_styles_1.validationError }, slaValidation)),
                        React.createElement("label", null, strings.seconds)))),
            React.createElement("div", { className: slaConfigure_styles_1.buttons },
                React.createElement(core_components_1.Button, { id: "sla-cancel", text: true, onClick: function () {
                        props.setModalClose();
                    } }, strings.slaCancel),
                React.createElement(core_components_1.Button, { id: "sla-apply", onClick: function () { return props.applyChange(sla, slaValidation, props.guid); } }, strings.slaApply)))));
}
exports.SlaConfigure = SlaConfigure;
